import axios from 'axios';
import store from '../Store/store';

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const apiKey = process.env.REACT_APP_OPEN_API_KEY;

const LinkPagamento = axios.create({
  baseURL: `${backendUrl}/open-api/v1/payment-links`,
  headers: {
    'Content-Type': 'application/json',
    ...(apiKey && { 'x-api-key': apiKey }),
  },
});

const getFilialLogada = () => {
  try {
    const filialOn = store.getState().filialOn;
    if (filialOn) return JSON.parse(filialOn).id;
  } catch (_) {}
  return '';
};

const getEmpresaLogada = () => {
  try {
    const empresaOn = store.getState().empresaOn;
    if (empresaOn) return JSON.parse(empresaOn).id;
  } catch (_) {}
  return '';
};

/**
 * Headers para Open API v1: x-api-key (já na instância), x-empresa e x-filial.
 * No checkout, empresa e filial devem vir da URL (useSearchParams/URLSearchParams).
 */
export const getContextHeaders = (empresa?: string | null, filial?: string | null) => {
  const empresaHeader = (empresa?.trim() && empresa) || getEmpresaLogada() || '';
  const filialHeader = (filial?.trim() && filial) || getFilialLogada() || '';
  return {
    'x-empresa': empresaHeader,
    'x-filial': filialHeader,
  };
};

function getErrorMessage(error: any): string {
  const erro = error.response?.data?.erro;
  if (erro?.mensagem) return erro.mensagem;
  if (error.response?.data?.message) return error.response.data.message;
  return 'Erro na requisição';
}

export async function findLinkById(
  _token: string,
  linkPagamentoId: string,
  empresa?: string | null,
  filial?: string | null,
  includeHistory?: boolean
): Promise<any> {
  try {
    if (!apiKey) throw new Error('REACT_APP_OPEN_API_KEY não configurada no .env');
    const response = await LinkPagamento.get(`/findById/${linkPagamentoId}`, {
      headers: getContextHeaders(empresa, filial),
      params: includeHistory ? { includeHistory: 'true' } : undefined,
    });
    const dados = response.data?.dados;
    return { statusCode: 200, data: dados };
  } catch (error: any) {
    console.error(`Erro ao buscar Link de Pagamento com ID ${linkPagamentoId}:`, error);
    throw new Error(getErrorMessage(error) || 'Erro ao buscar Link de Pagamento');
  }
}

export async function findPaymentMethodByLinkId(
  _token: string,
  linkPagamentoId: string,
  empresa?: string | null,
  filial?: string | null
): Promise<any> {
  try {
    if (!apiKey) throw new Error('REACT_APP_OPEN_API_KEY não configurada no .env');
    const response = await LinkPagamento.get(`/payment-method/findByLinkId/${linkPagamentoId}`, {
      headers: getContextHeaders(empresa, filial),
    });
    return { data: response.data?.dados };
  } catch (error: any) {
    console.error(`Erro ao buscar método de pagamento para o link com ID ${linkPagamentoId}:`, error);
    throw new Error(getErrorMessage(error) || 'Erro ao buscar método de pagamento');
  }
}

export async function createPaymentLinkHistory(
  _token: string,
  historyData: any,
  empresa?: string | null,
  filial?: string | null
): Promise<any> {
  try {
    if (!apiKey) throw new Error('REACT_APP_OPEN_API_KEY não configurada no .env');
    const response = await LinkPagamento.post('/history/create', historyData, {
      headers: getContextHeaders(empresa, filial),
    });
    return response.data?.dados;
  } catch (error: any) {
    console.error('Erro ao criar registro no histórico do link de pagamento:', error);
    throw new Error(getErrorMessage(error) || 'Erro ao criar histórico do link');
  }
}

export async function findHistoryByLinkId(
  _token: string,
  linkPagamentoId: string,
  params?: { page?: number; limit?: number } | object,
  empresa?: string | null,
  filial?: string | null
): Promise<any> {
  try {
    if (!apiKey) throw new Error('REACT_APP_OPEN_API_KEY não configurada no .env');
    const queryParams =
      params && typeof params === 'object' && 'page' in params
        ? { pagina: (params as { page?: number }).page, limite: (params as { limit?: number }).limit }
        : params;
    const response = await LinkPagamento.get(`/history/findByLinkId/${linkPagamentoId}`, {
      headers: getContextHeaders(empresa, filial),
      params: queryParams,
    });
    const dados = response.data?.dados;
    const items = Array.isArray(dados) ? dados : dados?.items ?? dados;
    return { data: items };
  } catch (error: any) {
    console.error(`Erro ao buscar histórico para o link com ID ${linkPagamentoId}:`, error);
    throw new Error(getErrorMessage(error) || 'Erro ao buscar histórico do link');
  }
}
